document.addEventListener("DOMContentLoaded", function () {
    function hideUpcartProperties() {
        const propertiesToHide = [
            'Disc Design Url Type',
            'Disc Assets',
            'Product ID',
            'Variant ID',
            'Is Custom Design Tool Enabled',
            'unique'
        ];

        document.querySelectorAll('.upcart-item-property strong').forEach(element => {
            const text = element.textContent.trim().replace(':', '');            

            if (text === 'Disc Design Url' || text === 'Design') {
                const property = element.closest('.upcart-item-property');
                const urlSpan = property.querySelector('span');
                const imageUrl = urlSpan ? urlSpan.textContent.trim() : '';

                if (imageUrl && imageUrl.startsWith('http')) {
                    property.innerHTML = '<strong>Design: </strong>';

                    const link = document.createElement('a');
                    link.href = imageUrl;
                    link.target = '_blank';
                    link.title = 'View full design';
                    link.textContent = 'View Design';
                    link.style.marginLeft = '5px';
                    link.style.color = '#0073e6';
                    link.style.textDecoration = 'underline';
                    link.style.cursor = 'pointer';

                    property.appendChild(link);
                }
            } else if (propertiesToHide.includes(text)) {
                element.closest('.upcart-item-property').style.display = 'none';
            }
        });

        document.querySelectorAll('.upcart-products-section .upcart-product-item, .upcart-products-section [class*="ProductRow__product"]').forEach(productElement => {
            let isDesignAdded = false;
            let isCustomDesignToolEnabled = false;

            // Search the entire innerHTML for trigger properties
            const html = productElement.innerHTML;
            
            if (html.includes('Is Custom Design Tool Enabled')) {
                isCustomDesignToolEnabled = true;
            }

            if (html.includes('Disc Design Url') || html.includes('Design:')) {
                // Check if there is an actual URL or "View Design" link
                if (html.includes('http') || html.includes('View Design')) {
                    isDesignAdded = true;
                }
            }
            
            // Hide any static "No Design Added" warning in fly-in cart
            const staticWarning = productElement.querySelector('.no-design-added-warning');
            if (staticWarning) {
                staticWarning.style.display = 'none';
            }

            // Add "No Design Added" label if triggered
            if (isCustomDesignToolEnabled && !isDesignAdded) {
                const existingLabel = productElement.querySelector('.no-design-label');
                if (!existingLabel) {
                    // Insert before quantity stepper (above it)
                    const anchor = productElement.querySelector('.styles_ProductRow__stepper__') ||
                                   productElement.querySelector('.upcart-item-quantity-wrapper');

                    if (anchor) {
                        const noDesignLabel = document.createElement('div');
                        noDesignLabel.className = 'no-design-label';
                        noDesignLabel.textContent = 'No Design Added';
                        noDesignLabel.style.cssText = `
                            font-size: 14px;
                            font-weight: 500;
                            text-align: center;
                            text-decoration: underline;
                            display: block !important;
                            visibility: visible !important;
                            color: #000;
                            margin: 5px 0;
                            cursor: pointer;
                        `;
                        anchor.parentNode.insertBefore(noDesignLabel, anchor);
                    }
                }
            } 
        });
    }

    function hideInUbantu() {
        // Only run on main cart page, not fly-in cart
        if (!window.location.pathname.includes('/cart')) return;

        const cartForm = document.querySelector('form#cart');
        if (!cartForm) return;
        
        const propertiesToHide = [
            'Disc Design Url Type',
            'Disc Assets',
            'Product ID',
            'Variant ID',
            'Is Custom Design Tool Enabled',
            'unique'
        ];


        cartForm.querySelectorAll('.cart__info').forEach((cartInfo) => {
            cartInfo.querySelectorAll('.line-item').forEach(item => {
                const label = item.querySelector('b');
                if (label) {
                    const text = label.textContent.trim().replace(':', '');                

                    if (propertiesToHide.includes(text)) {
                        item.style.display = 'none';
                    } else if (text === 'Disc Design Url' || text === 'Design') {
                        const urlSpan = item.querySelector('span');
                        const url = urlSpan ? urlSpan.textContent.trim() : '';                   

                        if (url && url.startsWith('http')) {
                            item.innerHTML = '<b>Design: </b>';

                            const link = document.createElement('a');
                            link.href = url;
                            link.target = '_blank';
                            link.title = 'View full design';
                            link.textContent = 'View Design';
                            link.style.marginLeft = '5px';
                            link.style.color = '#0073e6';
                            link.style.textDecoration = 'underline';
                            link.style.cursor = 'pointer';

                            item.appendChild(link);
                        }
                    }
                }
            });

            // Second pass for "No Design Added" warning
            let isDesignAdded = false;
            let isCustomDesignToolEnabled = false;
            
            // Search the whole text of the cartInfo container for triggers
            const containerText = cartInfo.textContent;
            if (containerText.includes('Is Custom Design Tool Enabled')) {
                isCustomDesignToolEnabled = true;
            }
            
            cartInfo.querySelectorAll('.line-item').forEach(li => {
                const b = li.querySelector('b');
                if (b && (b.textContent.includes('Design') || b.textContent.includes('Disc Design Url'))) {
                    const text = li.textContent;
                    if (text.includes('http') || li.querySelector('a')) {
                        isDesignAdded = true;
                    }
                }
            });

            if (isCustomDesignToolEnabled && !isDesignAdded && !cartInfo.querySelector('.no-design')) {
                const newItem = document.createElement('div');
                newItem.className = 'line-item no-design';
                newItem.innerHTML = `<b>No Design Added</b>`;
                newItem.style.cssText = `
                    font-weight: normal;
                    display: block !important;
                    width: 100%;
                    margin: 5px 0;
                    text-decoration: underline;
                    font-size: 14px;
                    cursor: pointer;
                    color: #000;
                    text-align: left;
                `;
                cartInfo.appendChild(newItem);
            }
        });
    }

    function hideProperties() {
        hideUpcartProperties();
        hideInUbantu();
    }

    // Run once on load
    hideProperties();

    // Debounce repeated cart DOM mutations into a single refresh.
    let hidePropertiesTimer = null;
    const observer = new MutationObserver(() => {
        clearTimeout(hidePropertiesTimer);
        hidePropertiesTimer = setTimeout(() => {
            hideProperties();
        }, 100);
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});
